import {
    getProviderAndGames,
    getProviderAndGamesAxios,
} from '@/api/providers.js';
import { sortProviderAndGameByName } from '@/scripts/tools.js';

export default {
    state: {
        providersAndGames: [],

        isShowNewProviderAndGames: false,

        isShowPAGProviderEdit: false,
        isSavePAGProviderEdit: false,
        PAGProviderEdit: null,

        isShowPAGProviderAdd: false,
        isSavePAGProviderAdd: false,
        PAGProviderAdd: {
            name: '',
            is_premium: false,
            is_default: false,
        },

        isShowPAGGameEdit: false,
        isSavePAGGameEdit: false,
        PAGGameEdit: null,

        isShowPAGGameAdd: false,
        isSavePAGGameAdd: false,
        PAGGameAdd: {
            name: '',
            provider_id: 0,
            is_default: false,
        },

        selectProvider: null,
        selectGame: null,
    },
    getters: {
        PROVIDERS_AND_GAMES: (state) => {
            return state.providersAndGames;
        },

        IS_SHOW_NEW_PROVIDER_AND_GAMES: (state) => {
            return state.isShowNewProviderAndGames;
        },

        // Provider Edit
        IS_SHOW_PAG_RROVIDER_EDIT: (state) => {
            return state.isShowPAGProviderEdit;
        },
        IS_SAVE_PAG_PROVIDER_EDIT: (state) => {
            return state.isSavePAGProviderEdit;
        },
        PAG_PROVIDER_EDIT: (state) => {
            return state.PAGProviderEdit;
        },

        // Provider Add
        IS_SHOW_PAG_PROVIDER_ADD: (state) => {
            return state.isShowPAGProviderAdd;
        },
        IS_SAVE_PAG_PROVIDER_ADD: (state) => {
            return state.isSavePAGProviderAdd;
        },
        PAG_PROVIDER_ADD: (state) => {
            return state.PAGProviderAdd;
        },

        // Game Edit
        IS_SHOW_PAG_GAME_EDIT: (state) => {
            return state.isShowPAGGameEdit;
        },
        IS_SAVE_PAG_GAME_EDIT: (state) => {
            return state.isSavePAGGameEdit;
        },
        PAG_GAME_EDIT: (state) => {
            return state.PAGGameEdit;
        },

        // Game Add
        IS_SHOW_PAG_GAME_ADD: (state) => {
            return state.isShowPAGGameAdd;
        },
        IS_SAVE_PAG_GAME_ADD: (state) => {
            return state.isSavePAGGameAdd;
        },
        PAG_GAME_ADD: (state) => {
            return state.PAGGameAdd;
        },

        SELECT_PROVIDER: (state) => {
            return state.selectProvider;
        },
        SELECT_GAME: (state) => {
            return state.selectGame;
        },
    },
    mutations: {
        PROVIDERS_AND_GAMES: (state, payload) => {
            sortProviderAndGameByName(payload);
            state.providersAndGames = payload;
        },
        PAG_PROVIDER_PUSH: (state, payload) => {
            state.providersAndGames.push(structuredClone(payload));
        },
        PAG_PROVIDER_UPDATE: (state, { id, payload }) => {
            const providerIndex = state.providersAndGames
                .map((provider) => provider.id)
                .indexOf(id);
            if (providerIndex >= 0) {
                state.providersAndGames[providerIndex] =
                    structuredClone(payload);
            }
        },
        PAG_PROVIDER_SPLIT: (state, id) => {
            const providerIndex = state.providersAndGames
                .map((provider) => provider.id)
                .indexOf(id);
            if (providerIndex >= 0)
                state.providersAndGames.splice(providerIndex, 1);
        },
        PAG_GAME_PUSH: (state, { providerID, payload }) => {
            const providerIndex = state.providersAndGames
                .map((provider) => provider.id)
                .indexOf(providerID);
            if (providerIndex >= 0) {
                state.providersAndGames[providerIndex].game_name.push(
                    structuredClone(payload)
                );
            }
        },
        PAG_GAME_UPDATE: (state, { providerID, gameID, payload }) => {
            const providerIndex = state.providersAndGames
                .map((provider) => provider.id)
                .indexOf(providerID);
            if (providerIndex < 0) return;
            const gameIndex = state.providersAndGames[providerIndex].game_name
                .map((game) => game.id)
                .indexOf(gameID);
            if (gameIndex >= 0) {
                state.providersAndGames[providerIndex].game_name[gameIndex] =
                    structuredClone(payload);
            }
        },
        PAG_GAME_SPLIT: (state, { gameID, providerID }) => {
            const providerIndex = state.providersAndGames
                .map((provider) => provider.id)
                .indexOf(providerID);
            if (providerIndex < 0) return;
            const gameIndex = state.providersAndGames[providerIndex].game_name
                .map((game) => game.id)
                .indexOf(gameID);
            if (gameIndex >= 0) {
                state.providersAndGames[providerIndex].game_name.splice(
                    gameIndex,
                    1
                );
            }
        },

        IS_SHOW_NEW_PROVIDER_AND_GAMES: (state, payload) => {
            state.isShowNewProviderAndGames = payload;
        },

        // Provider Edit
        IS_SHOW_PAG_RROVIDER_EDIT: (state, payload) => {
            state.isShowPAGProviderEdit = payload;
        },
        IS_SAVE_PAG_PROVIDER_EDIT: (state, payload) => {
            state.isSavePAGProviderEdit = payload;
        },
        PAG_PROVIDER_EDIT_SET: (state, payload) => {
            state.PAGProviderEdit = structuredClone(payload);
        },
        PAG_PROVIDER_EDIT_UPDATE: (state, { fieldName, fieldValue }) => {
            state.PAGProviderEdit[fieldName] = fieldValue;
        },

        // Provider Add
        IS_SHOW_PAG_PROVIDER_ADD: (state, payload) => {
            state.isShowPAGProviderAdd = payload;
        },
        IS_SAVE_PAG_PROVIDER_ADD: (state, payload) => {
            state.isSavePAGProviderAdd = payload;
        },
        PAG_PROVIDER_ADD_UPDATE: (state, { fieldName, fieldValue }) => {
            state.PAGProviderAdd[fieldName] = fieldValue;
        },

        // Game Edit
        IS_SHOW_PAG_GAME_EDIT: (state, payload) => {
            state.isShowPAGGameEdit = payload;
        },
        IS_SAVE_PAG_GAME_EDIT: (state, payload) => {
            state.isSavePAGGameEdit = payload;
        },
        PAG_GAME_EDIT_SET: (state, payload) => {
            state.PAGGameEdit = structuredClone(payload);
        },
        PAG_GAME_EDIT_UPDATE: (state, { fieldName, fieldValue }) => {
            state.PAGGameEdit[fieldName] = fieldValue;
        },

        // Game Add
        IS_SHOW_PAG_GAME_ADD: (state, payload) => {
            state.isShowPAGGameAdd = payload;
        },
        IS_SAVE_PAG_GAME_ADD: (state, payload) => {
            state.isSavePAGGameAdd = payload;
        },
        PAG_GAME_ADD_UPDATE: (state, { fieldName, fieldValue }) => {
            state.PAGGameAdd[fieldName] = fieldValue;
        },

        SELECT_PROVIDER: (state, payload) => {
            state.selectProvider = payload;
        },
        SELECT_GAME: (state, payload) => {
            state.selectGame = payload;
        },
    },
    actions: {
        CHECK_PROVIDERS_AND_GAMES: async function (context) {
            if (context.getters.PROVIDERS_AND_GAMES.length === 0) {
                context.dispatch('UPDATE_PROVIDER_AND_GAMES');
            }
        },
        CHECK_PROVIDERS_AND_GAMES_AXIOS: async function (context) {
            if (context.getters.PROVIDERS_AND_GAMES.length === 0) {
                const axiosPromise = await getProviderAndGamesAxios(
                    context.getters.IS_SHOW_NEW_PROVIDER_AND_GAMES
                ).catch((error) => {
                    return null;
                });
                return axiosPromise;
            }
            return null;
        },
        UPDATE_PROVIDER_AND_GAMES: async function (context) {
            context.commit(
                'PROVIDERS_AND_GAMES',
                await getProviderAndGames(
                    context.getters.IS_SHOW_NEW_PROVIDER_AND_GAMES
                )
            );
        },

        CHECK_PROVIDER_EDIT: async function (context) {
            const data = context.getters.PAG_PROVIDER_EDIT;
            if (data.name === '') {
                context.commit('IS_SAVE_PAG_PROVIDER_EDIT', false);
                return 'To save the provider, enter the name of the provider';
            }

            context.commit('IS_SAVE_PAG_PROVIDER_EDIT', true);
            return '';
        },
        CHECK_PROVIDER_ADD: async function (context) {
            const data = context.getters.PAG_PROVIDER_ADD;
            if (data.name === '') {
                context.commit('IS_SAVE_PAG_PROVIDER_ADD', false);
                return 'To create a provider, enter a name';
            }

            context.commit('IS_SAVE_PAG_PROVIDER_ADD', true);
            return '';
        },
        CHECK_GAME_EDIT: async function (context) {
            const data = context.getters.PAG_GAME_EDIT;
            if (data.name === '') {
                context.commit('IS_SAVE_PAG_GAME_EDIT', false);
                return 'To save a game, enter a name';
            }

            context.commit('IS_SAVE_PAG_GAME_EDIT', true);
            return '';
        },
        CHECK_GAME_ADD: async function (context) {
            const data = context.getters.PAG_GAME_ADD;
            if (data.name === '') {
                context.commit('IS_SAVE_PAG_GAME_ADD', false);
                return 'To create a game, enter a name';
            }

            if (data.provider_id == null || data.provider_id == 0) {
                context.commit('IS_SAVE_PAG_GAME_ADD', false);
                return 'To create a game, select provider';
            }

            context.commit('IS_SAVE_PAG_GAME_ADD', true);
            return '';
        },
    },
};
